export default "__VITE_ASSET__DjhXxbW7__"